import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Grid, Container } from '@mui/material';
import { Profile } from '../sections/@dashboard/manageUser';
import { useUserProfileQuery } from '../services/dvagent';
import { getToken } from '../services/LocalStorageService';
import { UserProfileCard } from '../components/skeleton';
import { Toaster } from '../sections/@dashboard/attributes';

export default function UserProfile() {

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({});
  const [userAccess, setUserAccess] = useState([]);
  const { data, isSuccess, error } = useUserProfileQuery(getToken());
  const [toasterData, setToasterData] = useState({
    trigger: false,
    status: true,
    symbol: '✔',
    message: '',
  });

  useEffect(() => {
    if (error) {
      if (error.status === 401) {
        // showToast(false, 'ⓘ', 'Unauthorized User');
        // storeAdmin("false");
        navigate('/');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong, server error');
      }
    }
    if (data && isSuccess) {
      setUser(data.data[0]);
      setUserAccess(data.userAccess);
      setLoading(true);
    }
  }, [data, isSuccess, error]);  

  const showToast = (status, symbol, message) => {
    setToasterData({
      trigger: true,
      status,
      symbol,
      message,
    });

    setTimeout(() => {
      setToasterData((prev) => ({
        ...prev,
        trigger: false,
      }));
    }, 5000); 
  };
  return (
    <>
      <Helmet>
        <title> DV Agent </title>
      </Helmet>
      {toasterData.trigger && (
        <Toaster
          trigger={toasterData.trigger}
          status={toasterData.status}
          symbol={toasterData.symbol}
          message={toasterData.message}
        />
      )}
      <Container maxWidth="xxl">
        {loading ? (
          <Grid container spacing={2}>
            <Profile user={user} access={userAccess}/>
          </Grid>
        ):(
          <Grid container spacing={2}>
            <UserProfileCard/>
          </Grid>
        )}
      </Container>
    </>
  );
}